const BgTwoStars = ({ className }: { className?: string }) => {
  return (
    <svg
      width="102"
      height="82"
      viewBox="0 0 102 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} pointer-events-none`}
    >
      <path
        d="M77.9752 0L84.6405 17.3099L102 23.9752L84.6405 30.6404L77.9752 48L71.3099 30.6902L54 23.9752L71.3099 17.3099L77.9752 0Z"
        fill="#3A3D50"
      />
      <path
        d="M10.9886 60L14.0435 67.9337L22 70.9886L14.0435 74.0435L10.9886 82L7.93369 74.0663L0 70.9886L7.93369 67.9337L10.9886 60Z"
        fill="#3A3D50"
      />
    </svg>
  );
};

export default BgTwoStars;
